module.exports = __webpack_public_path__ + "img/crown.d6b1f0e8.png";